import Error from '../model/Error.js';
import axios from 'axios';

export default class ChatViewRepository {

    static update(institutionKey, chatId) {
        let apiUrlPrefix = '';
        switch (institutionKey) {
            case 'club':
                apiUrlPrefix = '/club';
                break;
            case 'kindergarten':
                break;
            default:
                throw new Error(`Invalid institution key ${institutionKey}.`);
        }

        return new Promise((resolve, reject) => {
            axios
                .patch(`${apiUrlPrefix}/chats/${chatId}/chat-views`)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }
}
